import {Component, Input, OnInit} from '@angular/core';
import {IAiChatMessage} from '../ai-message/ai-message-view.model';

@Component({
  selector: 'app-ai-message-list',
  templateUrl: './ai-message-list.component.html',
  styleUrls: ['./ai-message-list.component.scss']
})
export class AiMessageListComponent implements OnInit {

  @Input() messages: IAiChatMessage[];
  @Input() avatarSize: 'small' | 'medium' | 'large' = 'medium';

  constructor() { }

  ngOnInit(): void {
  }

}
